<template>
    <div class="kgk-manage-companies">
        <div v-if="loading" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
        <div v-else-if="companies">
            <div v-if="companies.length > 0">
                <ul class="kgk-pagination">
                    <li v-for="page in pages" :key="page">
                        <router-link :to="'/admin/companies/' + page">{{ page }}</router-link>
                    </li>
                </ul>
                <table>
                    <thead>
                        <tr>
                            <th>Firmenname</th>
                            <th>Anzahl Mitglieder</th>
                            <th>Aktion</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(company, index) in pageCompanies" :key="company.identifier" :id="company.identifier">
                            <td>
                                <div class="kgk-mobile-th">Firmenname:</div>{{ company.name }}
                                <p>Manager: <a :href="'mailto:' + company.created_by">{{ company.created_by }}</a></p>
                            </td>
                            <td>
                                <div class="kgk-mobile-th">Anzahl Mitglieder:</div>
                                {{ company.member_count || '-' }}
                            </td>
                            <td>
                                <div class="kgk-mobile-th">Aktion</div>
                                <div class="kgk-form-row">
                                    <router-link :to="'/admin/challenges/' + company.identifier">
                                    <button type="submit">
                                        <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                                        <span class="button-text">Bearbeiten</span>
                                    </button>
                                </router-link>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <ul class="kgk-pagination">
                    <li v-for="page in pages" :key="page">
                        <router-link :to="'/admin/companies/' + page">{{ page }}</router-link>
                    </li>
                </ul>
            </div>
            <div v-else>
                <div class="spacer"></div>
                <p>Du hast hier leider keinen Zugriff.</p>
            </div>
        </div>
        
        <div v-else-if="error">
            <p>Fehler: {{error}}</p>
        </div>
    </div>
</template>

<script>
    import admin from '../../api/admin';

    export default {
        name: 'ManageCompanies',
        props: {
            page: Number,
            companiesPerPage: {
                type: Number,
                required: false,
                default: 20,
            }
        },
        components: {
        },
        data() {
            return {
                companies: [],
                loading: false,
                error: null,
            }
        },
        computed: {
            lastPage() {
                return Math.ceil(this.companies.length / this.companiesPerPage);
            },
            pages() {
                //return [...Array(this.lastPage).keys()].map(i => i + 1);
                return Array(this.lastPage).fill(1).map((i, offset) => i + offset);
            },
            pageCompanies() { // slice
                const start = (this.page - 1) * this.companiesPerPage;
                return this.companies.slice(start, start + this.companiesPerPage);
            }
        },
        methods: {
            cleanupCompanyEntry($comp){
                if($comp.competition_mode == 1){
                    return 'Ja';
                }else{
                    return 'nein';
                }
            },
            getCompetition($company){
                if($company.competition_identifier != null){
                    return $company.competition_start_date + " bis " + $company.competition_stop_date;
                }else{
                    return '-';
                }
            },
            loadCompanies() {
                this.loading = true;

                admin.getCompaniesFromServer(
                    this,
                    data => this.companies = data.companies,
                    () => this.error = 'Es ist ein Fehler aufgetreten',
                    () => this.loading = false,
                );
            },
        },
        mounted() {
            this.loadCompanies();
        }
    }

</script>